<div class="mainContainer card overflow-auto margin mt-4">
    <div class="loader" *ngIf="loading">
        <mat-spinner diameter="30"></mat-spinner>
    </div>
    <div class="reminder mb-0 d-flex bg-light justify-content-between flex-column flex-sm-row">
        <h5 class="card-title ps-4 mb-0 tableTitle">Invoices</h5>

        <div class="mb-0 d-flex align-items-center justify-content-end pe-4">
            <small class="text-muted me-3" [ngClass]="{'text-danger': selectedInvoices.length >= 10}">
                You can select up to 10 invoices ({{selectedInvoices.length}}/10 selected)
            </small>

            <button class="btn btn-primary btn-sm px-3 me-2" [disabled]="selectedInvoices.length === 0"
                (click)="sendSelectedInvoices()">
                Send Selected
            </button>
        </div>
    </div>


    <table matSort class="table table-hover table-nowrap">
        <thead class="table-light">
            <tr>
                <th scope="col">Select</th>
                <th mat-sort-header="candidate" scope="col">Contractor</th>
                <th mat-sort-header="client" scope="col">Client</th>
                <th mat-sort-header="job" scope="col">Job</th>
                <th mat-sort-header="invoice_date" scope="col">Invoice Date</th>
                <th mat-sort-header="due_date" scope="col">Due Date</th>
                <th mat-sort-header="total_pay" scope="col">Total Bill</th>
                <th mat-sort-header="status" scope="col">Status</th>
                <th mat-sort-header="actions" scope="col">Actions</th>
            </tr>
        </thead>
        <tbody>
            <ng-container *ngIf="invoices.length > 0">
                <tr class="dataColumn" *ngFor="let invoice of invoices">
                    <td>
                        <input type="checkbox" (change)="toggleInvoiceSelection(invoice, $event)"
                            [checked]="isSelected(invoice)" [disabled]="isDisabled(invoice)"
                            *ngIf="invoice.client_sent === INVOICE_STATUS.INVOICE_STATUS_CREATED">
                    </td>
                    <td>{{invoice.candidate}}</td>
                    <td>{{invoice.client}}</td>
                    <td>{{invoice.job}}</td>
                    <td>{{invoice.invoice_date}}</td>
                    <td>{{invoice.due_date}}</td>
                    <td>{{invoice.client_currency_format}} {{invoice.total_bill}}</td>
                    <td>
                        <div class="sheetStatus bg-opacity-20" [ngClass]="
                        invoice.client_sent === INVOICE_STATUS.INVOICE_STATUS_CREATED ? 'bg-primary text-primary' :
                        invoice.client_sent === INVOICE_STATUS.INVOICE_STATUS_SENT ? 'bg-success text-success' :
                        invoice.client_sent === INVOICE_STATUS.INVOICE_STATUS_QUEUED ? 'bg-warning text-warning' : ''">

                            <i class="bi" [ngClass]="
                        invoice.client_sent === INVOICE_STATUS.INVOICE_STATUS_CREATED ? 'bi-stopwatch-fill' :
                        invoice.client_sent === INVOICE_STATUS.INVOICE_STATUS_SENT ? 'bi-check-circle-fill' :
                        invoice.client_sent === INVOICE_STATUS.INVOICE_STATUS_QUEUED ? 'bi-hourglass-split' : ''">
                            </i>

                            <span class="d-flex align-items-center">
                                {{ invoice.client_sent_display }}
                            </span>
                        </div>
                    </td>
                    <td>
                        <div class="row-actions">
                            <button type="button" class="icon-btn-sm" (click)="viewInvoiceDetails(invoice, 'client')"
                                matTooltip="Edit Client Invoice" [matTooltipPosition]="'left'">
                                <i class="bi bi-eye"></i>
                            </button>

                            <button type="button" class="icon-btn-sm" (click)="downLoadInvoice(invoice, 'client')"
                                matTooltip="Download Contractor Invoice" [matTooltipPosition]="'left'">
                                <i class="bi bi-download"></i>
                            </button>
                        </div>
                    </td>
                </tr>
            </ng-container>
            <ng-container *ngIf="invoices.length == 0">
                <tr>
                    <td class="text-heading font-bold text-center">No records found</td>
                </tr>
            </ng-container>
        </tbody>
    </table>
    <div class="card-pagination" *ngIf="totalCount">
        <span class="pagination-summary">
            Showing {{ pageStart }}–{{ pageEnd }} of {{ totalCount }} invoices
        </span>
        <app-api-paginator [totalCount]="totalCount" (onStepChange)="onStepChange($event)"></app-api-paginator>
    </div>
</div>